const subscribeToWatchedEvent = (
    watchedEvent$,
    userActionsWatchedRequest$
) =>
    watchedEvent$
        .subscribe(watchedEvent => {
            const request = {
                assetId: watchedEvent.assetId,
                duration: watchedEvent.duration,
                type: watchedEvent.type,
                token: watchedEvent.token,
            };

            userActionsWatchedRequest$.next(request);
        });

export default subscribeToWatchedEvent;
